/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_StaffingRatios } from './models_StaffingRatios';
import type { models_StaffingThreshold } from './models_StaffingThreshold';
export type models_StaffingRequirements = {
    /**
     * CoverageCriticalPercent is the threshold below which coverage status becomes CRITICAL (default: 80)
     */
    coverage_critical_percent?: number;
    /**
     * CoverageWarningPercent is the threshold below which coverage status becomes WARNING (default: 100)
     */
    coverage_warning_percent?: number;
    /**
     * MinStaffPerUnit is an optional floor on required staff for a group (or a combined
     * unit of groups) while children are present. Nil means only the staffing model
     * applies. It never raises required staff for a slot with no children.
     */
    min_staff_per_unit?: number;
    /**
     * Model determines the calculation method: "threshold" or "ratio"
     */
    model: models_StaffingRequirements.model;
    /**
     * Ratios defines age-specific staff-to-child ratios (used when model = "ratio")
     */
    ratios?: models_StaffingRatios;
    /**
     * Thresholds defines step-based staffing brackets (used when model = "threshold")
     * Must be sorted by MaxWeightedPlaces ascending
     */
    thresholds?: Array<models_StaffingThreshold>;
};
export namespace models_StaffingRequirements {
    /**
     * Model determines the calculation method: "threshold" or "ratio"
     */
    export enum model {
        THRESHOLD = 'threshold',
        RATIO = 'ratio',
    }
}

